"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
/*
 * Copyright 2023, Polytechnique Montreal and contributors
 *
 * This file is licensed under the MIT License.
 * License text available at https://opensource.org/licenses/MIT
 */
const react_1 = __importDefault(require("react"));
const react_i18next_1 = require("react-i18next");
const InterviewsCreateNew_1 = __importDefault(require("./InterviewsCreateNew"));
const InterviewContext_1 = require("../../../contexts/InterviewContext");
const interview_1 = require("evolution-common/lib/services/interviews/interview");
const InterviewCreateLink = (props) => {
    const { state, dispatch } = react_1.default.useContext(InterviewContext_1.InterviewContext);
    if (state.status !== 'creating') {
        return (react_1.default.createElement("a", { href: "", id: 'interviewByResponseList_new', target: "_blank", rel: "noreferrer", onClick: (e) => {
                e.preventDefault();
                dispatch({
                    type: 'createNew',
                    username: `${interview_1.INTERVIEWER_PARTICIPANT_PREFIX}_${(Math.ceil(Math.random() * 8999) + 1000).toString()}`,
                    queryData: props.queryData
                });
            } }, props.t('admin:interviewSearch:CreateNew')));
    }
    else {
        return react_1.default.createElement(InterviewsCreateNew_1.default, null);
    }
};
/** Component used to add a link to create a new interview */
exports.default = (0, react_i18next_1.withTranslation)(['admin', 'main'])(InterviewCreateLink);
//# sourceMappingURL=InterviewsCreateLink.js.map